import Entity from '../entity'

export default class joinGroupBuyRecord extends Entity<number> {
   name:string="";
   phoneNumber:string="";
   remark:string="";
  }
  